import { all } from "redux-saga/effects";
import paypalSagas from "../components/paypal-connect/sagas";


export default function* root() {
  yield all([
    ...paypalSagas
  ]);
}
